import { render, staticRenderFns } from "./ModalRegistTemporaryStudent.vue?vue&type=template&id=c66860e6&scoped=true&lang=pug&"
import script from "./ModalRegistTemporaryStudent.vue?vue&type=script&lang=ts&"
export * from "./ModalRegistTemporaryStudent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66860e6",
  null
  
)

export default component.exports